<template>
	<footer class="navbar">
		<div class="container-fluid">
			<p class="text-center text-uppercase">
				<strong>{{ organization }} | {{ version }}</strong>
			</p>
		</div>
	</footer>
</template>

<script>
	import pkg from 'package.json';

	export default {
		data() {
			return {
				organization: pkg.organization,
				version: pkg.version
			};
		}
	};
</script>

<style scoped>
	footer {
		position: absolute;
		bottom: 0;
		width: 100%;
		margin: 0;
		border: 0;
		color: goldenrod;
		background: #286b86;
		border-radius: 0;
	}

	footer p {
		margin: 0;
		padding: 15px;
	}
</style>


// WEBPACK FOOTER //
// footer.vue?473e924e